import {
	DEFAULT_SORT_FIELD,
	SORT_FIELD_GROUP,
} from './Util';

class DySearchSortingController {
	static defaultSortAliases = [ 'relevanz', DEFAULT_SORT_FIELD ];

	constructor( selectEl ) {
		this.selectEl = selectEl;
		this.init();
	}

	static changeSorting( field, order ) {
		const url = new URL( window.location.href );

		if ( DySearchSortingController.defaultSortAliases.includes( field ) ) {
			url.searchParams.delete( SORT_FIELD_GROUP );
		} else {
			url.searchParams.set( SORT_FIELD_GROUP, field );
		}
		url.searchParams.delete( 'page' );
		url.searchParams.delete( 'pageNumber' );

		document.dispatchEvent( new CustomEvent( 'sort_items.acl', {
			detail: {
				sorting: field,
				order: order
			}
		} ) );

		window.location.href = url.toString();
	}

	init() {
		this.selectEl.addEventListener( 'change', ( event ) => {
			event.preventDefault();
			const selectedEl = this.selectEl.selectedOptions[ 0 ];
			const sorting = selectedEl?.dataset.sorting;
			const order = selectedEl?.dataset.order;

			if ( sorting ) {
				DySearchSortingController.changeSorting( sorting, order );
			}
		} );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.dy_sort_select' ).forEach( ( selectEl ) => {
		selectEl.DY_SEARCH_SORTING_CONTROLLER ??= new DySearchSortingController( selectEl );
	} );
} );
